import { gql } from "@apollo/client";

export const TENANT_EXPORT_CONFIG_FIELDS = gql`
  fragment TenantExportConfigFields on TenantExportConfigs {
    id
    bigqueryExportConfig {
      id
      createdAt
      settings {
        dataset
        gcsBucket
        gcsBucketPrefix
        location
      }
      lastRunJob {
        id
        type
        createdAt
        startedAt
        finishedAt
        progress
        resultJSON
        status
        errorMessage
      }
    }

    s3ExportConfig {
      createdAt
      settings {
        awsAccessKeyId
        awsRegion
        bucket
        prefix
        incremental
      }
      lastRunJob {
        id
        type
        createdAt
        startedAt
        finishedAt
        progress
        resultJSON
        status
        errorMessage
      }
    }
  }
`;

export const GET_TENANT_EXPORT_CONFIGS = gql`
  ${TENANT_EXPORT_CONFIG_FIELDS}
  query getTenantExportConfigs {
    tenantExportConfigs {
      ...TenantExportConfigFields
    }
  }
`;

export const GET_DATA_DICTIONARY = gql`
  query getDataDictionary {
    tenantExportDataDictionary {
      tableName
      description
      deprecated
      columns {
        columnName
        dataType
        description
        nullable
        deprecated
      }
    }
  }
`;

export const CREATE_S3_TENANT_EXPORT_CONFIG = gql`
  ${TENANT_EXPORT_CONFIG_FIELDS}
  mutation createS3TenantExportConfig(
    $input: CreateS3TenantExportConfigInput!
  ) {
    createS3TenantExportConfig(input: $input) {
      ...TenantExportConfigFields
    }
  }
`;

export const UPDATE_S3_TENANT_EXPORT_CONFIG = gql`
  ${TENANT_EXPORT_CONFIG_FIELDS}
  mutation updateS3TenantExportConfig(
    $input: UpdateS3TenantExportConfigInput!
  ) {
    updateS3TenantExportConfig(input: $input) {
      ...TenantExportConfigFields
    }
  }
`;

export const DELETE_S3_TENANT_EXPORT_CONFIG = gql`
  ${TENANT_EXPORT_CONFIG_FIELDS}
  mutation deleteS3TenantExportConfig {
    deleteS3TenantExportConfig {
      ...TenantExportConfigFields
    }
  }
`;

export const CREATE_BIGQUERY_TENANT_EXPORT_CONFIG = gql`
  ${TENANT_EXPORT_CONFIG_FIELDS}
  mutation createBigQueryTenantExportConfig(
    $input: CreateBigQueryTenantExportConfigInput!
  ) {
    createBigQueryTenantExportConfig(input: $input) {
      ...TenantExportConfigFields
    }
  }
`;

export const UPDATE_BIGQUERY_TENANT_EXPORT_CONFIG = gql`
  ${TENANT_EXPORT_CONFIG_FIELDS}
  mutation updateBigQueryTenantExportConfig(
    $input: UpdateBigQueryTenantExportConfigInput!
  ) {
    updateBigQueryTenantExportConfig(input: $input) {
      ...TenantExportConfigFields
    }
  }
`;

export const DELETE_BIGQUERY_TENANT_EXPORT_CONFIG = gql`
  ${TENANT_EXPORT_CONFIG_FIELDS}
  mutation deleteBigQueryTenantExportConfig {
    deleteBigQueryTenantExportConfig {
      ...TenantExportConfigFields
    }
  }
`;
